import api from "services/axiosInstance";
import { UpdateSplitSheet } from "services/uploadMusic/updateSplitSheet";
import { IMusicData } from "types/musicData";

export const EditMetadata = async (data: IMusicData, trackId: string) => {
  try {
    let res;
    if (data.releaseType === "SINGLE") {
      if (data.trackList[0].split && data.trackList[0].splitSheetId) {
        await UpdateSplitSheet(
          data.trackList[0].split,
          data.trackList[0].splitSheetId
        );
      }

      res = await api.patch(`/songs/${trackId}`, {
        ...data
      });
    } else {
      for (const track of data.trackList) {
        if (track.split && track.splitSheetId) {
          await UpdateSplitSheet(track.split, track.splitSheetId);
        }
      }
      res = await api.patch(`/containers/${trackId}`, {
        ...data
      });
    }

    return res;
  } catch (error) {
    throw error;
  }
};




